module.exports = __webpack_public_path__ + "media/images/help/payment_fees-ddc27002956de262cbc5b6e0b982551e.jpeg";